export const BASE_URL = "https://maintain-cmms.netlify.com";
export const CRYPTR_SECRET_KEY = "5590djKlsieqclfd6FUkqweYz5d7";
export const VIDEO_TUTORIALS_LINK =
  "https://www.youtube.com/playlist?list=PLOKq5lxYcVO_znIyDmFnW7IGUXDAqx0yt";

export const PRIORITIES = [
  {
    value: "NONE",
    label: "None"
  },
  {
    value: "LOW",
    label: "Low"
  },
  {
    value: "MEDIUM",
    label: "Medium"
  },
  {
    value: "HIGH",
    label: "High"
  }
];

export const WORK_ORDER_STATUSES = [
  {
    value: "OPEN",
    label: "Open"
  },
  {
    value: "ON_HOLD",
    label: "On Hold"
  },
  {
    value: "IN_PROGRESS",
    label: "In Progress"
  },
  {
    value: "COMPLETE",
    label: "Complete"
  }
];

export const RECURRENCE = [
  {
    value: "day",
    label: "Day"
  },
  {
    value: "weeks",
    label: "Week"
  },
  {
    value: "months",
    label: "Month"
  }
];



// WEBPACK FOOTER //
// ./src/Utils/Consts.ts